import { SelectOption } from '@garner-health/components-common';

import { CareGoal, careGoalsClient, geocodeClient } from '~/clients';
import { Position, serializePosition } from '~/util';

export type CareGoalSelectOption = SelectOption & CareGoal;

export type LocationSelectOption = SelectOption & {
  position: Position;
};

export async function getCareGoalsSelectOptions(
  params: { query: string } | { id: string },
): Promise<CareGoalSelectOption[]> {
  const careGoals = await careGoalsClient.getCareGoals(params);
  return careGoals.map(careGoal => ({
    ...careGoal,
    label: careGoal.term,
    value: careGoal.id,
  }));
}

export async function getGeocodeLocationSelectOptions(input: string): Promise<LocationSelectOption[]> {
  return geocodeClient.geocodeLocation(input).then(locations =>
    locations.map(location => ({
      label: location.formattedAddress,
      value: serializePosition(location.position),
      position: location.position,
    })),
  );
}

export const MAX_PROVIDER_ROW_SELECTIONS = 5;
export const PROVIDER_ID_LOCATION_ID_DELIMETER = '__PROVIDER_ID_LOCATION_ID_DELIMETER__';

/**
 * Encode provider ID (of format p.123abc) to a format that is usable by react hook form,
 * without creating a nested object
 *
 * This is required because if given fields of p.abc123 and p.def456 react hook form will represent that as
 * ```json
 *   {
 *     "p": {
 *       "abc123": "value1",
 *       "def456": "value"
 *      }
 *    }
 * ```
 * which is unintiuitive and then difficult to work with if the field are dynamic
 */
export function encodeProviderIdForReactHookForm(providerId: string, locationId: string | undefined): string {
  const stringToEncode = locationId ? `${providerId}${PROVIDER_ID_LOCATION_ID_DELIMETER}${locationId}` : providerId;
  return btoa(stringToEncode);
}

/**
 * Decoding compliment to encodeProviderIdForReactHookForm
 * @see encodeProviderIdForReactHookForm
 */
export function decodeProviderIdForReactHookForm(encodedId: string) {
  return atob(encodedId);
}
